import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Flex, Image, Link, Text } from 'pcln-design-system';
const StyledImage = /*#__PURE__*/styled(Image).withConfig({
  displayName: "HeroItem__StyledImage",
  componentId: "sc-6ubv7g-0"
})(["object-fit:cover;&:hover{box-shadow:", ";}"], themeGet('shadows.xl'));
const StyledLink = /*#__PURE__*/styled(Link).withConfig({
  displayName: "HeroItem__StyledLink",
  componentId: "sc-6ubv7g-1"
})(["&:hover{cursor:pointer;}"]);
export default function HeroItem({
  imageSrc,
  alt,
  heading,
  paragraph,
  href,
  onClick
}) {
  return React.createElement(StyledLink, {
    href: href,
    target: '_blank',
    onClick: onClick,
    tabIndex: -1
  }, React.createElement(Flex, {
    key: heading,
    flexDirection: 'column'
  }, React.createElement(StyledImage, {
    alt: alt,
    width: 187,
    height: 160,
    src: imageSrc,
    borderRadius: 'lg',
    loading: 'lazy'
  }), React.createElement(Flex, {
    maxWidth: 187,
    flexDirection: 'column',
    style: {
      gap: '4px'
    },
    mt: 3,
    pl: 1
  }, React.createElement(Text, {
    textStyle: 'heading6',
    color: 'text'
  }, heading), React.createElement(Text, {
    textStyle: 'paragraph',
    color: 'text',
    textWrap: 'wrap'
  }, paragraph))));
}